<template>
  <div id="app">
  	<Vheader></Vheader>
   <router-view  :key="key"/>
    <Vfooter></Vfooter>
  </div>
</template>

<script>
	import Vheader from './components/header'
	import Vfooter from './components/footer'
export default {
  name: 'app',
  components : {
  	Vheader,
  	Vfooter
  },
  computed: {
    key() {
        return this.$route.name !== undefined? this.$route.name + +new Date(): this.$route + +new Date()
    }
 }
}
</script>

<style>
#app {
  font-family: 'Microsoft YaHei', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.bannerMask {
  width: 100%; 
  height: 0; 
  background: red;
  position: relative;
}
.case-nav{
  position: absolute;
  width: 100%;
  background: #f7f7f7;
  height: 90px;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  margin-top: -3vw;
}
.bannerMask div {
  position: absolute;
  width: 100%; 
  height: 3vw;
  background: #fff;
  top: -3vw;
}

</style>



// WEBPACK FOOTER //
// src/App.vue